import { render } from "./FormWebsiteField.vue?vue&type=template&id=06733f4e&scoped=true"
import script from "./FormWebsiteField.vue?vue&type=script&lang=js"
export * from "./FormWebsiteField.vue?vue&type=script&lang=js"

import "./FormWebsiteField.vue?vue&type=style&index=0&id=06733f4e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-06733f4e"

export default script